import {
	getCoreRowModel,
	getSortedRowModel,
	useReactTable,
} from "@tanstack/react-table";
import { useTranslate } from "@tolgee/react";
import type { HistoricalOrder } from "#/hooks/use-hyperliquid-account";
import { ORDER_HISTORY_GRID_CLASS } from "./constants/positions.constants.ts";
import { orderHistoryColumns } from "./order-history-columns.tsx";
import { VirtualizedGridTable } from "./virtualized-grid-table.tsx";

const coreRowModel = getCoreRowModel();
const sortedRowModel = getSortedRowModel();

type OrderHistoryTableProps = {
	orderHistory: HistoricalOrder[];
	isError?: boolean;
	onRetry?: () => void;
};

export function OrderHistoryTable({
	orderHistory,
	isError,
	onRetry,
}: OrderHistoryTableProps) {
	const { t } = useTranslate();

	const table = useReactTable({
		data: orderHistory,
		columns: orderHistoryColumns,
		getCoreRowModel: coreRowModel,
		getSortedRowModel: sortedRowModel,
	});

	return (
		<VirtualizedGridTable
			table={table}
			gridClass={ORDER_HISTORY_GRID_CLASS}
			estimateSize={36}
			emptyMessage={t("positions.no-order-history")}
			isError={isError}
			onRetry={onRetry}
		/>
	);
}
